<template>
  <div class="h-100">
    <explore-personas
      @slide_window="$emit('slide_window')"
      @update-settings="updateSettings"
      :data_settings="data_settings"
      v-if="category_selected.category === 'personas'"
    ></explore-personas>

    <explore-assistants
      @slide_window="$emit('slide_window')"
      @update-settings="updateSettings"
      @assistant-selected="$emit('assistant-selected', $event)"
      :data_settings="data_settings"
      v-if="category_selected.category === 'assistants'"
    ></explore-assistants>

    <chat
      v-if="isAssistantCategory"
      @slide_window="$emit('slide_window')"
      @update-settings="updateSettings"
      @redirect-explore-assistants="$emit('redirect-explore-assistants')"
      @update_credits="$emit('update_credits', $event)"
      :data_settings="data_settings"
      :credits_avaible="credits_avaible"
    ></chat>

  </div>
</template>

<script>

export default {
  name: "ContainerAssistants",
  components: {
    ExplorePersonas: () => import('@/views/components/brandme-ai/ExplorePersonas.vue'),
    ExploreAssistants: () => import('@/views/components/brandme-ai/ExploreAssistants.vue'),
    chat: () => import('@/views/components/brandme-ai/chat.vue')
  },
  props: {
    category_selected: { type: Object, required: true },
    data_settings: { type: Object, default: null },
    credits_avaible: { type: Number, default: 0 }
  },
  computed: {
    isAssistantCategory() {
      const assistantSlugs = [
        'social-post',
        'song-writer',
        'product-review',
        'video-script',
        'rewrite',
        'brand-pitch',
        'email-campaign'
      ];
      
      return assistantSlugs.includes(this.category_selected.category);
    }
  },
  methods: {
    updateSettings(newSettings) {
      this.$emit('update-settings', newSettings);
    }
  }

};
</script>